const defaultState = {
    drawer: null,
    isMini: false,
};

const mutations = {
    toggleDrawer(state, open) {
        state.drawer = open;
    },
    toggleMini(state, mini) {
        state.isMini = mini;
    },
};

const actions = {
    toggleDrawer({ commit }, open) {
        commit('toggleDrawer', open);
    },
    toggleMini({ commit }, mini) {
        commit('toggleMini', mini);
    },
};

const getters = {
    drawer: state => state.drawer,
    isMini: state => state.isMini,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
